module.exports = __webpack_public_path__ + "aef3f9e31ad2624f771049c614dfe822.gif";